<template>
  <div class="brandManagePage">
    <div class="classBox">
      <div class="classItem" :class="{'isActive':index==selClass}"
           v-for="(item,index) in shopList" @click="changeClass(index)" :key="index">
        {{item.cangkuname}}
        <i class="el-icon-caret-right" v-if="index==selClass" style="font-size: larger"></i>
      </div>
    </div>
    <div class="brandManageContent">
      <input type="file" ref="fileupload" style="display: none;" @change="change1($event)"/>
      <div style="float: left">总数：{{totalnumber}}</div>
      <el-button style="float: right;" type="primary" @click="jingjia"><i class="el-icon-folder-add"></i> 导入</el-button>
      <el-button style="float: right;margin-right: 30px"><a href="./static/file/《眼镜智慧通》镜架导入模板.xlsx"><i class="el-icon-paperclip"></i>下载导入模板</a></el-button>

      <el-table
        :data="tableData"
        stripe
        border size="mini"
        style="width: 100%">
        <el-table-column
          width="50"
          label="序号"
          align="center">
          <template slot-scope="scope">
            {{1+scope.$index}}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="品牌"
          align="left" header-align="center">
        </el-table-column>
        <el-table-column
          prop="model"
          label="型号"
          align="left"
          width="150" header-align="center">
        </el-table-column>
        <el-table-column
          prop="color"
          label="规格"
          width="150"
          align="left" header-align="center">
        </el-table-column>
        <el-table-column
          prop="number"
          label="数量"
          width="150"
          align="left" header-align="center">
        </el-table-column>
        <el-table-column
          prop="price"
          label="零售价"
          width="150"
          align="left" header-align="center">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
  import {getListData} from '@/api/set/jxcstore';
  import {jingjiaupload} from '@/api/set/jxcgooddetail';
  import {listGoodsRight} from '@/api/set/jxcgoodscategory'
  import {listInit} from '@/api/set/jxcstoreformdetail';


export default {
  components: {

  },
  data() {
    return {
      totalnumber:0,
      selClass:"",
      shopList: [],
      goodsList:[],
      tableData: [],
      brand: '',
    }
  },
  methods: {
    changeClass(index) {
      this.selClass = index;
      this.bindTable();
    },
    bindTable() {
      this.totalnumber=0;
      listInit({cangkucode: this.shopList[this.selClass].cangkucode}).then(response => {
        var rows = response.data.obj;
        var arr = []
        for (let i in rows) {
          var p = JSON.parse(rows[i].packagesize)
          arr.push({
            name: rows[i].seedname.replace(p.M, ''),
            model: p.M,
            color: p.C,
            number: rows[i].totalnumber,
            price: rows[i].price
          })
          this.totalnumber += parseInt(rows[i].totalnumber);
        }
        this.tableData=arr;
      })
    },
    jingjia() {
      this.$refs.fileupload.value = ""
      this.$refs.fileupload.click()
    },
    change1(event) {
      try {
        var reg = /(\.xls|\.xlsx)$/
        if (!reg.test(event.target.files[0].name)) {
          this.$message.error("只能导入.xls或者.xlsx的文件！")
          return
        }
        this.$importExcel(event.target.files[0], (data) => {

          let arr = []
          if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
            for (let j in data) {
              let obj = {categoryname: '', categorycode: '', xilie: '', model: '', color: ''}
              obj.categoryname = data[j]['品牌'];
              // obj.xilie = data[j]['系列']?data[j]['系列'].replace(/ /g, ""):'';
              if (obj.categoryname == null)
                obj.categoryname = "";
              obj.categoryname = obj.categoryname.replace(/ /g, "");
              if (obj.categoryname == "") {
                this.$message.error("品牌必须填写！");
                return;
              }

              for (let i in this.goodsList) {
                if (this.goodsList[i].categoryname == obj.categoryname) {
                  obj.categorycode = this.goodsList[i].categorycode;
                }
              }

              if (obj.categorycode == '') {
                this.$message.error("镜架品牌《" + obj.categoryname + "》不存在，请返回上一步增加！");
                return;
              }

              obj.model = data[j]['型号'] ? data[j]['型号'].replace(/ /g, "").toUpperCase() : '';
              if (obj.model == '') {
                this.$message.error("型号必须填写！");
                return;
              }
              obj.color = (data[j]['规格'] ? data[j]['规格'] : (data[j]['色号'] ? data[j]['色号'] : '')).toUpperCase().replace(/ /g, "");
              obj.minnumber = data[j]['数量'] ? parseInt(data[j]['数量'].replace(/ /g, "")) : 0;

              if (!(obj.minnumber >= 0)) {
                this.$message.error("数量格式不正确，必须是大于等于0的整数！");
                return;
              }
              obj.seedname = obj.categoryname + obj.model;
              obj.goodsframe = '[{"model":"' + obj.model + '","color":"' + obj.color + '"}]'
              obj.filltemplate = 80
              obj.seedunit = '副'
              obj.pricetype = 1
              obj.bom = 0
              obj.enabled = 1
              obj.advertisement = ''
              obj.sortnum = 0
              obj.nostock = -1;//data[j]['是否备货'] != null && data[j]['是否备货'] == '备货' ? 1 :
              obj.noscancode = -1;//data[j]['是否扫唯一码出入库'] != null && data[j]['是否扫唯一码出入库'] == '是' ? 1 :

              obj.refsellprice = data[j]['零售价'] ? parseFloat(data[j]['零售价'].replace(/ /g, "")) : 0;
              if (!(obj.refsellprice > 0)) {
                this.$message.error("零售价格式不正确，必须是大于0的数字！");
                return;
              }
              for (let m in arr) {
                if (arr[m].categorycode == obj.categorycode && arr[m].goodsframe == obj.goodsframe) {
                  this.$message.error("《" + obj.categoryname + " " + obj.model + " " + obj.color + "》存在多条记录，请合并后导入！");
                  return;
                }
              }
              arr.push(obj);
            }
          }

          if (arr.length == 0) {
            this.$message.error("未读取到数据！")
          } else {
            this.$confirm('是否确定导入到' + this.shopList[this.selClass].cangkuname + '，共' + arr.length + '条记录?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              jingjiaupload({
                  arr: JSON.stringify(arr),
                  init: "1",
                  cangkucode: this.shopList[this.selClass].cangkucode,
                  cangkuname: this.shopList[this.selClass].cangkuname
                }
              ).then(response => {
                if (response.data.code == 0) {
                  this.$message({
                    type: 'success',
                    message: '导入成功！'
                  });
                  this.bindTable();
                }
              });
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });

          }
        })
      } catch (ee) {
        this.$message.error("导入失败")
      }
    },
    finishFn(callback) {
      if (callback) {
        callback(true);
      }
    }
  },
  mounted() {
    //经营的品牌
    listGoodsRight({}).then(response=>{
      var item=response.data.obj;
      for(let i in item){
        if(item[i].categorycode.startsWith("002")||item[i].categorycode.startsWith("003")||item[i].categorycode.startsWith("004")){
          this.goodsList.push(item[i])
        }
      }
    })

    //仓库
    getListData({}).then(response=> {
      this.shopList = response.data.obj.rows;
      this.changeClass(this.shopList.length > 1 ? 1 : 0);
    });
    //this.bindTable(true);
  },
}
</script>
<style scoped>
  .brandManagePage{
    display: flex;
    border: 0px solid #ccc;
  }

  .brandManagePage .classBox{
    -webkit-box-flex: 0;
    -ms-flex: none;
    flex: none;
    width: 15%;
    background: #eaf4ff;
    padding: 0px 0;
    color: #333;
    height: 100%;
    overflow: auto;
    relation:fixed;
    min-height:calc(100vh - 325px);;
  }

  .brandManagePage .brandManageContent {
    padding: 0px 15px 0px 15px;
    width: 85%;
    margin: 0 auto;
    height: 100%;
    overflow: auto;
    min-height:calc(100vh - 325px);;
  }

  .classItem.isActive {
    color: #3e96f7;
  }

  .classItem {
    cursor: pointer;
    padding: 0 27px 0 30px;
    position: relative;
    text-align: left;
    font-size: 16px;
    height: 42px;
    line-height: 42px;
  }


  .box-card {
    width: 100%;
    margin-left: 0px;
    margin-bottom: 25px;
    min-height: 180px;
    text-align: left;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }
  .clearfix:after {
    clear: both
  }

  .clearfix span{
    float:left;
    font-weight:600;
    font-size:14px;
  }
</style>



// WEBPACK FOOTER //
// src/views/childComp/FrameStock.vue